<app-timer *ngIf="showTimer; else reminder" [class.ios]="isIOS" [countdownDuration]="delay" (timerEnded)="onTimerEnded()"></app-timer>
<ng-template #reminder>
    <ion-button expand="block" (click)="onSendReminder()">Send Reminder</ion-button>
</ng-template>
